import { Injectable } from '@angular/core';
//import  { Http } from '@angular/http';
//import {data} from './data';
//import { Headers } from '@angular/http';
//import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
@Injectable()

export class MyUrlService {
	KILOSABJIURL : string;
	HOMEURL : string;
	LOGINURL : string;
	SIGNUPURL : string;
	OTPURL : string;
	SENDOTP:string;
	PRODUCTURL : string;
	PRODUCTDETAILURL :string;
	IMAGEURL : string;
	KILOPARTYPRODUCTURL:string;
	ADDTOCARTURL :string;
	MYCARTURL : string;
	BOOKINGURL : string;
	FORGOTPASS : string;
	UPDATEORDERURL:string;
	DELETORDER :string;
	ORDERHISTORY:string;
	ORDERHISTORYDETAIL:string;
	PROFILEURL:string;
	PROFILEUPDATE:string;
	USERADDRESS:string;
	MYCARTPRODUCTVIEW:string;
	DELIVERYDATE:string;
	KILOPOINT:string;
	MYCARTCHECKOUTCAll:string;
	PAYTMURL:string;
	PAYTMPMtCOMPLET:string;
	REFERRALCODE:string;
	PAYTMPAGE:string;
  	KILOPARTYORDERVIEW:string;
	RATINGWEBSERVICES:string;
	CHECKPRODUCTEXIST:string;
	constructor() {
		this.KILOSABJIURL = "http://app.kilosubzi.com";
		//this.KILOSABJIURL ="http://192.168.0.101/kilosabji";
		this.HOMEURL =this.KILOSABJIURL +'/api/home';
		this.LOGINURL =this.KILOSABJIURL +'/api/login';
		this.SIGNUPURL =this.KILOSABJIURL +'/api/signup';
		this.OTPURL =this.KILOSABJIURL +'/api/signupotp';
		this.SENDOTP = this.KILOSABJIURL +'/api/sendotp';
		this.PRODUCTURL =this.KILOSABJIURL +'/api/product';
		this.PRODUCTDETAILURL =this.KILOSABJIURL +'/api/productdetail';
		this.IMAGEURL = "http://app.kilosubzi.com/public/images/2";
		//this.IMAGEURL = "http://192.168.0.101/kilosabji/public/images/2";
		this.KILOPARTYPRODUCTURL = this.KILOSABJIURL +'/api/kilopartyproduct';
		this.ADDTOCARTURL =this.KILOSABJIURL +'/api/addtocart';
		this.MYCARTURL = this.KILOSABJIURL +'/api/mycart';
		this.BOOKINGURL = this.KILOSABJIURL +'/api/booking';
		this.FORGOTPASS = this.KILOSABJIURL +'/api/forgotpassword';
		this.UPDATEORDERURL = this.KILOSABJIURL +'/api/updateorder';
		this.DELETORDER = this.KILOSABJIURL +'/api/deleteorder';
		this.ORDERHISTORY = this.KILOSABJIURL +'/api/orderhistory';
		this.ORDERHISTORYDETAIL =this.KILOSABJIURL +'/api/orderhistorydetail';
		this.PROFILEURL = this.KILOSABJIURL +'/api/profile';
		this.PROFILEUPDATE = this.KILOSABJIURL +'/api/profileupdate';
		this.USERADDRESS = this.KILOSABJIURL +'/api/useraddress';
		this.MYCARTPRODUCTVIEW = this.KILOSABJIURL +'/api/mycartproductview';
		this.DELIVERYDATE = this.KILOSABJIURL +'/api/deliverydatecart';
		this.KILOPOINT = this.KILOSABJIURL +'/api/kilopoint';
		this.MYCARTCHECKOUTCAll = this.KILOSABJIURL +'/api/confrimpayment';
		this.PAYTMURL = this.KILOSABJIURL +'/api/paytmpayment';
		this.PAYTMPMtCOMPLET = this.KILOSABJIURL +'/api/paytmcompletion';
		this.REFERRALCODE = this.KILOSABJIURL +'/api/referralcode';
		this.PAYTMPAGE = this.KILOSABJIURL +'/api/paytmpage';
		this.KILOPARTYORDERVIEW= this.KILOSABJIURL+'/api/kilopartyorderview';
		this.RATINGWEBSERVICES= this.KILOSABJIURL+'/api/updaterating';
		this.CHECKPRODUCTEXIST= this.KILOSABJIURL+'/api/kiloproductvalidate';
		
	}
}

















//constructor(private _http: Http ) { }

/* private Url = 'http://sethies.com/kilosabjiapp/api/home';  // URL to web API

constructor (private http: Http) {}

getHeroes(): Observable<data[]> {
return this.http.get(this.Url)
.map(this.extractData)
.catch(this.handleError);
}

create(name: string): Observable<data> {
// private Url = 'http://sethies.com/kilosabjiapp/api/home';  // URL to web API
let headers = new Headers({ 'Content-Type': 'application/json' });
let options = new RequestOptions({ headers: headers });

return this.http.post(this.Url, { name }, options)
.map(this.extractData)
.catch(this.handleError);
}

private extractData(res: Response) {
let body = res.json();
return body.data || { };

//console.log(let body);
}

private handleError (error: Response | any) {
// In a real world app, you might use a remote logging infrastructure
let errMsg: string;
if (error instanceof Response) {
const body = error.json() || '';
const err = body.error || JSON.stringify(body);
errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
} else {
errMsg = error.message ? error.message : error.toString();
}
console.error(errMsg);
return Observable.throw(errMsg);
}
}*/






//constructor(private _http: Http ) { }

//public getCountryDetail() {


//let _url: string = 'https://restcountries.eu/rest/v2/name/india?fullText=true';

// let headers = new Headers({'Content-Type':'application/json'});
// let test_this = {"name": "ravi"};
//let _url: string="http://sethies.com/kilosabjiapp/api/home";

//create(name: string): Observable<data> {
// private Url = 'http://sethies.com/kilosabjiapp/api/home';  // URL to web API
// let headers = new Headers({ 'Content-Type': 'application/json' });
//let options = new RequestOptions({ headers: headers });

/* create(name: string): Observable<Hero> {
let headers = new Headers({ 'Content-Type': 'application/json' });
let options = new RequestOptions({ headers: headers });

return this.http.post(this.heroesUrl, { name }, options)
.map(this.extractData)
.catch(this.handleError);
}





//console.log(JSON.stringify(test_this));

//return this._http.post(_url,  test_this , options);
//.catch(this.handleError);

//  return this._http.post( _url,test_this );

//  return this._http.get(encoded_data, this._url, options).map(
//  (res: Response) => res.json() || {}

}
}

/*import {Injectable} from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

@Injectable()

export class MydataService {
public headers:Headers;

constructor( private _http: Http){
//this.method =_http.get;
//this.http = http;

this.headers = new Headers();
this.headers.append('Content-Type', 'application/json');
//  this.headers.append('Accept', 'application/json');
// this.headers.append('Access-Control-Allow-Origin', '*');
this.headers.append('Access-Control-Allow-Origin','*');
// this.headers.append('Access-Control-Allow-Headers', 'Content-Type');

}
public getCountryDetail() {
let _url: string = 'https://restcountries.eu/rest/v2/name/india?fullText=true';
//let _url: string = 'http://192.168.0.104/kilosabji/api/home';
// let _url: string = 'http://sethies.com/kilosabjiapp/api/home';
return this._http.get(_url,{headers:this.headers});
// return this._http.get( _url );
}

}*/



// WEBPACK FOOTER //
// ./src/pages/home/checkUrll.ts